import { render, staticRenderFns } from "./Instructors.vue?vue&type=template&id=503563ca&scoped=true"
import script from "./Instructors.vue?vue&type=script&lang=js"
export * from "./Instructors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503563ca",
  null
  
)

export default component.exports